export const sizes = [
  {
    label: "4",
    sizeId: "4"
  },
  {
    label: "6",
    sizeId: "6"
  },
  {
    label: "8",
    sizeId: "8"
  },
  {
    label: "10",
    sizeId: "10"
  },
  {
    label: "12",
    sizeId: "12"
  },
  {
    label: "14",
    sizeId: "14"
  },
  {
    label: "16",
    sizeId: "16"
  },
  {
    label: "18",
    sizeId: "18"
  },
  {
    label: "20",
    sizeId: "20"
  },
  {
    label: "One Size",
    sizeId: "OneSize"
  }
];
